import script from "./ExamComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ExamComponent.vue?vue&type=style&index=0&id=6508a68e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6508a68e"]])

export default __exports__